export default {
    'searchList': {
        'searchTxt': [{
            'name': '起运地',
            'value': 'starAdder',
            'filterable': true,
            'unfold': true,
            'config': {
                'checkStrictly': true
            },
            'type': 'addressSelect',
            'span': 3
        }, {
            'name': '目的地',
            'value': 'endAdder',
            'filterable': true,
            'unfold': true,
            'config': {
                'checkStrictly': true
            },
            'type': 'addressSelect',
            'span': 3
        }, {
            'name': '预计到车时间',
            'value': 'createTime',
            'startTime': 'beginDate',
            'endTime': 'endDate',
            'startPlaceholder': '开始日期',
            'endPlaceholder': '结束日期',
            'type': 'time',
            'unfold': true,
            'span': 7
        }, {
            'name': '车型',
            'value': 'dispatchNo',
            'type': 'input',
            'unfold': false,
            'span': 3
        }, {
            'name': '创建时间',
            'value': 'createTime',
            'startTime': 'beginDate',
            'endTime': 'endDate',
            'startPlaceholder': '创建开始日期',
            'endPlaceholder': '创建结束日期',
            'type': 'time',
            'unfold': false,
            'span': 7
        }],
        'unfoldState': false,
        'advancedBtn': true
    },
    'table':
    {
        'clickState': false,
        'selectBtn': true,
        'height': 400,
        'columns': [
            {
                'label': '目的地',
                'prop': 'dispatchNo',
                'width': '148px'
            },
            {
                'label': '分公司',
                'prop': 'siteName',
                'width': '100px'
            },
            {
                'label': '服务平台',
                'prop': 'senderProvinceName',
                'width': '86px'
            },
            {
                'label': '常用车型',
                'prop': 'senderCityName',
                'width': '86px'
            },
            {
                'label': '装载量',
                'prop': 'senderDistrictName',
                'width': '86px'
            },
            {
                'label': '比例',
                'prop': 'receiverProvinceName',
                'width': '86px'
            },
            {
                'label': '状态',
                'prop': 'receiverCityName',
                'width': '88px'
            },
            {
                'label': '生效时间',
                'prop': 'receiverDistrictName',
                'width': '86px'
            },
            {
                'label': '失效时间',
                'prop': 'driver',
                'width': '70px'
            }],
        'action': [
            {
                'type': 'text',
                'label': '编辑',
                'size': 'mini',
                'event': 'edit'
            }
        ],
        'leftOperation': true
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50, 100] // eslint-disable-line
    }
};
